import { api } from '../config/api';

// ===================== MOTIVOS DE TRANSFERÊNCIA =====================

export const motivosTransferenciaService = {
  listar: () => api.get('/visitas-config/motivos-transferencia'),
  criar: (motivo: string, gravidade?: string) => api.post('/visitas-config/motivos-transferencia', { motivo, gravidade }),
  excluir: (id: string) => api.delete('/visitas-config/motivos-transferencia/' + id),
};

// ===================== MOTIVOS DE CANCELAMENTO =====================

export const motivosCancelamentoService = {
  listar: () => api.get('/visitas-config/motivos-cancelamento'),
  criar: (motivo: string, gravidade?: string) => api.post('/visitas-config/motivos-cancelamento', { motivo, gravidade }),
  excluir: (id: string) => api.delete('/visitas-config/motivos-cancelamento/' + id),
};

// ===================== MOTIVOS DE REPROVAÇÃO =====================

export const motivosReprovacaoService = {
  listar: () => api.get('/visitas-config/motivos-reprovacao'),
  criar: (motivo: string, gravidade?: string) => api.post('/visitas-config/motivos-reprovacao', { motivo, gravidade }),
  excluir: (id: string) => api.delete('/visitas-config/motivos-reprovacao/' + id),
};

// ===================== MOTIVOS DE REAGENDAMENTO =====================

export const motivosReagendamentoService = {
  listar: () => api.get('/visitas-config/motivos-reagendamento'),
  criar: (motivo: string, gravidade?: string) => api.post('/visitas-config/motivos-reagendamento', { motivo, gravidade }),
  excluir: (id: string) => api.delete('/visitas-config/motivos-reagendamento/' + id),
};

// ===================== MOTIVOS DE FINALIZAÇÃO =====================

export const motivosFinalizacaoService = {
  listar: () => api.get('/visitas-config/motivos-finalizacao'),
  criar: (motivo: string, gravidade?: string) => api.post('/visitas-config/motivos-finalizacao', { motivo, gravidade }),
  excluir: (id: string) => api.delete('/visitas-config/motivos-finalizacao/' + id),
};

// ===================== QUESTIONÁRIO DE AVALIAÇÃO =====================

export const avaliacaoConfigService = {
  listar: () => api.get('/visitas-config/avaliacao-config'),
  criar: (pergunta: string, ordem: number) => api.post('/visitas-config/avaliacao-config', { pergunta, ordem }),
  atualizar: (id: string, pergunta: string, ordem: number) => api.put('/visitas-config/avaliacao-config/' + id, { pergunta, ordem }),
  excluir: (id: string) => api.delete('/visitas-config/avaliacao-config/' + id),
};

// ===================== AVALIAÇÕES =====================

export const avaliacoesService = {
  buscarPorVisita: (visitaId: string) => api.get('/visitas-config/avaliacoes/' + visitaId),
  salvar: (visita_id: string, respostas: any[], observacao?: string) =>
    api.post('/visitas-config/avaliacoes', { visita_id, respostas, observacao }),
};

// ===================== TENTATIVAS DE VISITA =====================

export const tentativasVisitaService = {
  listar: (comprador_id?: string, status?: string) => {
    let url = '/visitas-config/tentativas-visita';
    const params = new URLSearchParams();
    if (comprador_id) params.append('comprador_id', comprador_id);
    if (status) params.append('status', status);
    const qs = params.toString();
    return api.get(qs ? url + '?' + qs : url);
  },
  criar: (data: any) => api.post('/visitas-config/tentativas-visita', data),
  aprovar: (id: string) => api.post('/visitas-config/tentativas-visita/' + id + '/aprovar', {}),
  reprovar: (id: string, motivo_reprovacao: string, observacao_reprovacao?: string) =>
    api.post('/visitas-config/tentativas-visita/' + id + '/reprovar', { motivo_reprovacao, observacao_reprovacao }),
};
